import type { AccountMovementKind, AgingBucketLabel } from './api';

/** `customer-account-statement/spec.md`: no internal code is ever shown to the user, only its Spanish label. */
export const ACCOUNT_MOVEMENT_KIND_LABELS: Record<AccountMovementKind, string> = {
  INITIAL_BALANCE: 'Saldo inicial',
  INVOICE: 'Factura',
  PAYMENT: 'Recibo',
};

/** `customer-account-statement/spec.md` → "Antigüedad de deuda": `CURRENT` is the not-yet-due bucket. */
export const AGING_BUCKET_LABELS: Record<AgingBucketLabel, string> = {
  CURRENT: 'Corriente',
  '0-30': '1 a 30 días',
  '31-60': '31 a 60 días',
  '61-90': '61 a 90 días',
  '90+': 'Más de 90 días',
};
